import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @closeModal={{@closeModal}}
  @title={{i18n "topic.publish_page.title"}}
  class="publish-page-modal"
>
  <:body>
    {{#if this.unpublished}}
      <p>{{i18n "topic.publish_page.unpublished"}}</p>
    {{else}}
      <ConditionalLoadingSpinner @condition={{this.initializing}}>
        <p class="publish-description">{{i18n
            "topic.publish_page.description"
          }}</p>

        <form>
          <div class="controls">
            <label>{{i18n "topic.publish_page.slug"}}</label>
            <TextField
              @value={{this.publishedPage.slug}}
              @onChange={{this.checkSlug}}
              @onChangeImmediate={{this.startCheckSlug}}
              @disabled={{this.existing}}
              class="publish-slug"
            />
          </div>

          <div class="controls">
            <label>{{i18n "topic.publish_page.public"}}</label>

            <p class="description">
              <Input
                @type="checkbox"
                @checked={{readonly this.publishedPage.public}}
                {{on "click" this.onChangePublic}}
              />
              {{i18n "topic.publish_page.public_description"}}
            </p>
          </div>
        </form>

        <div class="publish-url">
          <ConditionalLoadingSpinner @condition={{this.checking}} />

          {{#if this.existing}}
            <div class="current-url">
              {{i18n "topic.publish_page.publish_url"}}
              <div>
                <a
                  href={{this.publishedPage.url}}
                  target="_blank"
                  rel="noopener noreferrer"
                >{{this.publishedPage.url}}</a>
              </div>
            </div>
          {{else}}
            {{#if this.showUrl}}
              <div class="valid-slug">
                {{i18n "topic.publish_page.preview_url"}}
                <div class="example-url">{{this.publishedPage.url}}</div>
              </div>
            {{/if}}

            {{#if this.invalid}}
              {{i18n "topic.publish_page.invalid_slug"}}
              <span class="invalid-slug">{{this.reason}}.</span>
            {{/if}}
          {{/if}}

        </div>
      </ConditionalLoadingSpinner>
    {{/if}}
  </:body>
  <:footer>
    {{#if this.showUnpublish}}
      <DButton
        @label="topic.publish_page.unpublish"
        @icon="trash-alt"
        @isLoading={{this.unpublishing}}
        @action={{this.unpublish}}
        class="btn-danger"
      />

      <DButton
        @icon="times"
        @label="close"
        @action={{@closeModal}}
        class="close-publish-page"
      />
    {{else if this.unpublished}}
      <DButton
        @label="topic.publish_page.publishing_settings"
        @action={{this.startNew}}
      />
    {{else}}
      <DButton
        @label="topic.publish_page.publish"
        @icon="file"
        @disabled={{this.disabled}}
        @isLoading={{this.saving}}
        @action={{this.publish}}
        class="btn-primary publish-page"
      />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "U2jypP9n",
  "block": "[[[8,[39,0],[[24,0,\"publish-page-modal\"]],[[\"@closeModal\",\"@title\"],[[30,1],[28,[37,1],[\"topic.publish_page.title\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n\"],[41,[30,0,[\"unpublished\"]],[[[1,\"      \"],[10,2],[12],[1,[28,[35,1],[\"topic.publish_page.unpublished\"],null]],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,3],null,[[\"@condition\"],[[30,0,[\"initializing\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[10,2],[14,0,\"publish-description\"],[12],[1,[28,[35,1],[\"topic.publish_page.description\"],null]],[13],[1,\"\\n\\n        \"],[10,\"form\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,1],[\"topic.publish_page.slug\"],null]],[13],[1,\"\\n            \"],[8,[39,4],[[24,0,\"publish-slug\"]],[[\"@value\",\"@onChange\",\"@onChangeImmediate\",\"@disabled\"],[[30,0,[\"publishedPage\",\"slug\"]],[30,0,[\"checkSlug\"]],[30,0,[\"startCheckSlug\"]],[30,0,[\"existing\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,[28,[35,1],[\"topic.publish_page.public\"],null]],[13],[1,\"\\n\\n            \"],[10,2],[14,0,\"description\"],[12],[1,\"\\n              \"],[8,[39,5],[[4,[38,7],[\"click\",[30,0,[\"onChangePublic\"]]],null]],[[\"@type\",\"@checked\"],[\"checkbox\",[28,[37,6],[[30,0,[\"publishedPage\",\"public\"]]],null]]],null],[1,\"\\n              \"],[1,[28,[35,1],[\"topic.publish_page.public_description\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"publish-url\"],[12],[1,\"\\n          \"],[8,[39,3],null,[[\"@condition\"],[[30,0,[\"checking\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"existing\"]],[[[1,\"            \"],[10,0],[14,0,\"current-url\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"topic.publish_page.publish_url\"],null]],[1,\"\\n              \"],[10,0],[12],[1,\"\\n                \"],[10,3],[15,6,[30,0,[\"publishedPage\",\"url\"]]],[14,\"target\",\"_blank\"],[14,\"rel\",\"noopener noreferrer\"],[12],[1,[30,0,[\"publishedPage\",\"url\"]]],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showUrl\"]],[[[1,\"              \"],[10,0],[14,0,\"valid-slug\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"topic.publish_page.preview_url\"],null]],[1,\"\\n                \"],[10,0],[14,0,\"example-url\"],[12],[1,[30,0,[\"publishedPage\",\"url\"]]],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"invalid\"]],[[[1,\"              \"],[1,[28,[35,1],[\"topic.publish_page.invalid_slug\"],null]],[1,\"\\n              \"],[10,1],[14,0,\"invalid-slug\"],[12],[1,[30,0,[\"reason\"]]],[1,\".\"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"  \"]],[]],[[[1,\"\\n\"],[41,[30,0,[\"showUnpublish\"]],[[[1,\"      \"],[8,[39,8],[[24,0,\"btn-danger\"]],[[\"@label\",\"@icon\",\"@isLoading\",\"@action\"],[\"topic.publish_page.unpublish\",\"trash-alt\",[30,0,[\"unpublishing\"]],[30,0,[\"unpublish\"]]]],null],[1,\"\\n\\n      \"],[8,[39,8],[[24,0,\"close-publish-page\"]],[[\"@icon\",\"@label\",\"@action\"],[\"times\",\"close\",[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"unpublished\"]],[[[1,\"      \"],[8,[39,8],null,[[\"@label\",\"@action\"],[\"topic.publish_page.publishing_settings\",[30,0,[\"startNew\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,8],[[24,0,\"btn-primary publish-page\"]],[[\"@label\",\"@icon\",\"@disabled\",\"@isLoading\",\"@action\"],[\"topic.publish_page.publish\",\"file\",[30,0,[\"disabled\"]],[30,0,[\"saving\"]],[30,0,[\"publish\"]]]],null],[1,\"\\n    \"]],[]]]],[]]],[1,\"  \"]],[]]]]]],[\"@closeModal\"],false,[\"d-modal\",\"i18n\",\"if\",\"conditional-loading-spinner\",\"text-field\",\"input\",\"readonly\",\"on\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/publish-page.hbs",
  "isStrictMode": false
});